// ADHOC: aligned on contract https://curl.se/libcurl/c/CURLOPT_SEEKFUNCTION.html
export enum CurlSeekOrigin {
  SET = 0,
  CUR = 1,
  END = 2
}
